export default __webpack_public_path__ + "static/media/CV_FR.02e1239b.pdf";